import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

interface SubHeaderItem {
  icon: string;
  iconTooltip?: Record<{key?: string, text?: string}>;
  label: string;
  labelTooltip?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppChartCardSubHeader',
  props: {
    items: {},
    removeMarginBottom: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-chart-card-sub-header", { 'no-margin-bottom': __props.removeMarginBottom }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (subHeaderItem, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "app-chart-card-sub-header-item",
        "data-testid": "app-chart-card-sub-header-item"
      }, [
        _withDirectives(_createElementVNode("i", {
          class: _normalizeClass(['icon', 'app-chart-card-sub-header-item-icon', subHeaderItem.icon])
        }, null, 2), [
          [_directive_clean_tooltip, _ctx.t(subHeaderItem.iconTooltip.key)]
        ]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _withDirectives((_openBlock(), _createElementBlock("p", null, [
          _createTextVNode(_toDisplayString(subHeaderItem.label), 1)
        ])), [
          [_directive_clean_tooltip, subHeaderItem.labelTooltip]
        ])
      ]))
    }), 128))
  ], 2))
}
}

})